import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { PhoneIcon } from 'lucide-react';
type Props = {
  /** When true, hides the phone number and "Request a Tour" button (e.g. on the thank-you page). */
  minimal?: boolean;
};
export function Header({
  minimal = false
}: Props) {
  const [scrolled, setScrolled] = useState(false);
  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    onScroll();
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);
  return <header className={`sticky top-0 z-50 w-full bg-cream/95 backdrop-blur transition-shadow ${scrolled ? 'shadow-sm' : ''}`} data-id="element-61" data-mp="31bys2pr9v7gm">
      <div className="mx-auto flex max-w-7xl items-center justify-between gap-4 px-5 py-4 lg:px-8" data-id="element-62" data-mp="36a0dhhc67iv9">
        {/* Logo */}
        <Link to="/" className="flex items-center" aria-label="Brightwood Club home" data-id="element-63" data-mp="3bbpqh2iye6lz">
          <img src="https://cdn.magicpatterns.com/uploads/tCQXAyf27S5jD65deaMCFt/Brighwood-Club-Logo-300x101.png" alt="Brightwood Club" className="h-12 w-auto sm:h-14" data-id="element-64" data-mp="3f9dls6ok61ee" />
        </Link>

        {!minimal && <div className="flex items-center gap-4" data-id="element-65" data-mp="2mng8b10hd6h5">
            <a href="tel:4109673980" className="hidden items-center gap-2 text-lg font-bold text-neutral-800 transition-colors hover:text-forest md:flex lg:text-xl" data-id="element-66" data-mp="2hnliz1wcsoy7">
              <PhoneIcon className="h-5 w-5 text-forest" data-id="element-67" data-mp="3acj0v3wnkjqf" />
              410-967-3980
            </a>
            <a href="/#connect" className="rounded-sm bg-forest px-7 py-4 text-sm font-bold uppercase tracking-widest text-white transition-colors hover:bg-forest-dark lg:text-base" data-id="element-68" data-mp="35l9ce6mubmg4">
              Request a Tour
            </a>
          </div>}
      </div>
    </header>;
}